<p-toast position="top-right" role="status" aria-live="polite" aria-atomic="true"></p-toast>

<!-- Loading State -->
@if (isCheckingStatus()) {
  <div class="flex justify-content-center align-items-center" style="min-height: 400px;">
    <div class="text-center">
      <p-progressSpinner 
        styleClass="w-4rem h-4rem" 
        strokeWidth="4" 
        fill="transparent"
        animationDuration=".5s"
      ></p-progressSpinner>
      <p class="mt-3 text-color-secondary">Verifica stato registrazione...</p>
    </div>
  </div>
}

<!-- ========================================== -->
<!-- AXA USER VIEW: Mode Selection + Invitation -->
<!-- ========================================== -->
@if (isAXAUser() && !isCheckingStatus()) {
  <div class="invitation-container p-6 w-full">
    <!-- Page Header -->
    <section class="page-header mb-5" aria-labelledby="page-heading">
      <div class="header-content">
        <div class="header-left">
          <i class="pi pi-send header-icon" aria-hidden="true"></i>
          <div class="header-text">
            <h1 id="page-heading">Invita Nuovo Fiduciario</h1>
            <p class="subtitle">Genera e invia il link di registrazione al fiduciario</p>
          </div>
        </div>
      </div>
    </section>

    <!-- STEP 1: Mode Selection -->
    @if (registrationMode() === null && generatedInvitation() === null) {
      <p-card>
        <div class="mode-selection">
          <h2 class="text-xl font-semibold mb-4 text-center">Come vuoi procedere con la registrazione?</h2>
          
          <div class="grid">
            <!-- Direct Mode Card -->
            <div class="col-12 md:col-6">
              <div 
                class="mode-card surface-100 border-round p-4 cursor-pointer hover:surface-200 transition-colors transition-duration-200"
                (click)="selectMode('DIRECT')"
              >
                <div class="flex flex-column align-items-center text-center gap-3">
                  <div class="mode-icon-wrapper surface-0 border-circle p-4">
                    <i class="pi pi-user text-4xl" style="color: #00125b;"></i>
                  </div>
                  <h3 class="text-lg font-semibold m-0">Registrazione Diretta</h3>
                  <p class="text-color-secondary line-height-3 m-0">
                    Il fiduciario riceverà il link e compilerà i dati autonomamente dopo l'autenticazione CIAM
                  </p>
                  <p-button 
                    label="Seleziona" 
                    icon="pi pi-arrow-right" 
                    styleClass="w-full mt-2"
                    severity="primary"
                  ></p-button>
                </div>
              </div>
            </div>

            <!-- Delegated Mode Card -->
            <div class="col-12 md:col-6">
              <div 
                class="mode-card surface-100 border-round p-4 cursor-pointer hover:surface-200 transition-colors transition-duration-200"
                (click)="selectMode('DELEGATED')"
              >
                <div class="flex flex-column align-items-center text-center gap-3">
                  <div class="mode-icon-wrapper surface-0 border-circle p-4">
                    <i class="pi pi-users text-4xl" style="color: #00125b;"></i>
                  </div>
                  <h3 class="text-lg font-semibold m-0">Registrazione Delegata</h3>
                  <p class="text-color-secondary line-height-3 m-0">
                    Compila tu i dati del fiduciario per conto suo, poi invia il link per gli step successivi
                  </p>
                  <p-button 
                    label="Seleziona" 
                    icon="pi pi-arrow-right" 
                    styleClass="w-full mt-2"
                    severity="primary"
                  ></p-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-card>
    }

    <!-- STEP 2A: Direct Mode - Email and Basic Info -->
    @if (registrationMode() === 'DIRECT' && generatedInvitation() === null) {
      <p-card>
        <div class="mb-3">
          <button
            pButton
            type="button"
            icon="pi pi-arrow-left"
            label="Indietro"
            severity="secondary"
            size="small"
            (click)="backToModeSelection()"
            class="mb-3"
          ></button>
          
          <h2 class="text-xl font-semibold mb-2">Registrazione Diretta</h2>
          <p class="text-color-secondary">
            Il fiduciario riceverà il link e compilerà autonomamente i dati dopo l'autenticazione CIAM.
          </p>
        </div>

        <div class="formgrid grid">
          <!-- Cognome -->
          <div class="field col-12 md:col-6">
            <label for="family-name-direct" class="font-semibold block mb-2">
              <i class="pi pi-user mr-2"></i>
              Cognome Rappresentante Legale
              <span class="text-red-500" aria-hidden="true">*</span>
            </label>
            <input
              pInputText
              id="family-name-direct"
              type="text"
              [(ngModel)]="familyName"
              placeholder="Cognome Rappresentante Legale"
              class="w-full"
            />
          </div>

          <!-- Nome -->
          <div class="field col-12 md:col-6">
            <label for="given-name-direct" class="font-semibold block mb-2">
              <i class="pi pi-user mr-2"></i>
              Nome Rappresentante Legale
              <span class="text-red-500" aria-hidden="true">*</span>
            </label>
            <input
              pInputText
              id="given-name-direct"
              type="text"
              [(ngModel)]="givenName"
              placeholder="Nome Rappresentante Legale"
              class="w-full"
            />
          </div>
        </div>

        <div class="field">
          <label for="email-direct" class="font-semibold block mb-2">
            <i class="pi pi-envelope mr-2"></i>
            Email del Fiduciario
            <span class="text-red-500" aria-hidden="true">*</span>
          </label>
          <input
            pInputText
            id="email-direct"
            type="email"
            [(ngModel)]="email"
            placeholder="esempio@email.it"
            class="w-full"
            (keyup.enter)="createAndSendInvitation()"
          />
        </div>

        <div class="field">
          <label for="confirm-email-direct" class="font-semibold block mb-2">
            <i class="pi pi-envelope mr-2"></i>
            Conferma Email
            <span class="text-red-500" aria-hidden="true">*</span>
          </label>
          <input
            pInputText
            id="confirm-email-direct"
            type="email"
            [(ngModel)]="confirmEmail"
            placeholder="Conferma email"
            class="w-full"
            (keyup.enter)="createAndSendInvitation()"
          />
          @if (confirmEmail() && email() !== confirmEmail()) {
            <small class="text-red-500" role="alert">Le email non corrispondono</small>
          }
        </div>

        <p-button
          label="Crea e Invia Invito"
          icon="pi pi-send"
          styleClass="w-full"
          [loading]="isLoading()"
          [disabled]="!givenName() || !familyName() || !email() || !confirmEmail() || email() !== confirmEmail() || isLoading()"
          (onClick)="createAndSendInvitation()"
        ></p-button>
      </p-card>
    }

    <!-- STEP 2B: Delegated Mode - Full Form -->
    @if (registrationMode() === 'DELEGATED' && generatedInvitation() === null && showForm()) {
      <button
        pButton
        type="button"
        icon="pi pi-arrow-left"
        label="Indietro"
        severity="secondary"
        size="small"
        (click)="backToModeSelection()"
        class="mb-3"
      ></button>

      <!-- Sezione Dati Anagrafici (same style as Fiduciario) -->
      <section class="surface-0 border-round p-5 mb-4 shadow-1" aria-labelledby="dati-anagrafici-delegated-heading">
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-user text-2xl" style="color: #00125b;" aria-hidden="true"></i>
          <h2 id="dati-anagrafici-delegated-heading" class="text-xl font-semibold m-0" style="color: #00125b;">Registrazione Delegata</h2>
        </div>

        <!-- Form for DELEGATED mode (AXA fills data for fiduciario) -->
        <form (ngSubmit)="save()" #preRegistrationForm="ngForm" class="p-fluid">
          <div class="grid">
            <!-- Categoria Fiduciario -->
            <div class="field col-12 md:col-6">
              <label for="type" class="font-semibold block mb-2">
                Categoria Fiduciario 
                <span class="text-red-500" aria-hidden="true">*</span>
              </label>
              <p-select
                inputId="type"
                name="type"
                #typeField="ngModel"
                [options]="tipologieOptions()"
                [ngModel]="preRegister()['type']"
                (ngModelChange)="onFiduciarioChange($event)"
                optionLabel="name"
                optionValue="code"
                placeholder="Seleziona categoria"
                class="w-full"
                required
              ></p-select>
              @if (typeField.invalid && typeField.touched) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>

            <!-- Categoria Carrozzeria (Conditional) -->
            @if (isBodyShopSelected()) {
              <div class="field col-12 md:col-6">
                <label for="bodyShopType" class="font-semibold block mb-2">
                  Categoria Carrozzeria 
                  <span class="text-red-500" aria-hidden="true">*</span>
                </label>
                <p-select
                  inputId="bodyShopType"
                  name="bodyShopType"
                  #bodyShopTypeField="ngModel"
                  [options]="bodyworkOptions()"
                  [ngModel]="preRegister()['bodyShopType']"
                  (ngModelChange)="onBodyShopTypeChange($event)"
                  optionLabel="name"
                  optionValue="code"
                  placeholder="Seleziona categoria carrozzeria"
                  class="w-full"
                  required
                ></p-select>
                @if (bodyShopTypeField.invalid && bodyShopTypeField.touched) {
                  <small class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }

            <!-- Persona Giuridica o Fisica -->
            <div class="field col-12 md:col-6">
              <label for="legalOrPhysical" class="font-semibold block mb-2">
                Persona Giuridica o Fisica 
                <span class="text-red-500" aria-hidden="true">*</span>
              </label>
              <p-select
                inputId="legalOrPhysical"
                name="legalOrPhysical"
                #legalOrPhysicalField="ngModel"
                [options]="personTypeOptions()"
                [ngModel]="preRegister()['legalOrPhysical']"
                (ngModelChange)="onPersonTypeChange($event)"
                optionLabel="label"
                optionValue="value"
                placeholder="Seleziona tipo persona"
                class="w-full"
                required
              ></p-select>
              @if (legalOrPhysicalField.invalid && legalOrPhysicalField.touched) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>

            <!-- Ragione Sociale (for GIURIDICA) -->
            <div class="field col-12 md:col-6">
              <label for="businessName" class="font-semibold block mb-2">
                Ragione Sociale
                @if (isBusinessNameRequired()) {
                  <span class="text-red-500" aria-hidden="true">*</span>
                }
              </label>
              <input
                pInputText
                id="businessName"
                name="businessName"
                #businessNameField="ngModel"
                [(ngModel)]="preRegister()['businessName']"
                class="w-full"
                placeholder="Denominazione dell'azienda"
                [required]="isBusinessNameRequired()"
              />
              @if (businessNameField.invalid && businessNameField.touched) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
              <small class="block mt-1 text-600">Non inserire il tipo di società</small>
            </div>

            <!-- Tipo Società  -->
            <div class="field col-12 md:col-4">
              <label for="tipo-societa" class="font-semibold block mb-2">
                Tipo Società <span class="text-red-500" aria-hidden="true">*</span>
              </label>
              <p-select
                inputId="companyType"
                name="companyType"
                #companyTypeField="ngModel"
                [ngModel]="preRegister()['companyType']"
                (ngModelChange)="onCompanyTypeChange($event)"
                [options]="filteredSupplierTypes()"
                optionLabel="label"
                optionValue="value"
                optionDisabled="disabled"
                panelStyleClass="company-type-select-panel"
                placeholder="-- Seleziona --"
                [filter]="true"
                [showClear]="true"
                class="w-full"
                required
              ></p-select>
              @if (companyTypeField.invalid && companyTypeField.touched) {
                <small id="companyType-error" class="text-red-500" role="alert">
                  Campo obbligatorio
                </small>
              }
            </div>

            <!-- Cognome -->
            <div class="field col-12 md:col-6">
              <label for="lastName" class="font-semibold block mb-2">
                Cognome Rappresentante Legale
                @if (isLastNameRequired()) {
                  <span class="text-red-500" aria-hidden="true">*</span>
                }
              </label>
              <input
                pInputText
                id="lastName"
                name="lastName"
                #lastNameField="ngModel"
                [(ngModel)]="preRegister()['lastName']"
                class="w-full"
                placeholder="Cognome del titolare"
                [required]="isLastNameRequired()"
              />
              @if (lastNameField.invalid && lastNameField.touched) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>

            <!-- Nome -->
            <div class="field col-12 md:col-6">
              <label for="firstName" class="font-semibold block mb-2">
                Nome Rappresentante Legale
                @if (isFirstNameRequired()) {
                  <span class="text-red-500" aria-hidden="true">*</span>
                }
              </label>
              <input
                pInputText
                id="firstName"
                name="firstName"
                #firstNameField="ngModel"
                [(ngModel)]="preRegister()['firstName']"
                class="w-full"
                placeholder="Nome del titolare"
                [required]="isFirstNameRequired()"
              />
              @if (firstNameField.invalid && firstNameField.touched) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>

            <!-- Codice Fiscale -->
            <div class="field col-12 md:col-6">
              <label for="fiscalCode" class="font-semibold block mb-2">
                Codice Fiscale 
                @if (isFiscalCodeRequired()) {
                  <span class="text-red-500" aria-hidden="true">*</span>
                }
              </label>
              <input
                pInputText
                id="fiscalCode"
                name="fiscalCode"
                #fiscalCodeField="ngModel"
                [ngModel]="preRegister()['fiscalCode']"
                (ngModelChange)="updatePreRegistrationFiscalCode($event)"
                placeholder="es. RSSMRA80A01H501U o es. 12345678901"
                class="w-full"
                maxlength="16"
                pattern="^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})|([0-9]{11})$"
                [required]="isFiscalCodeRequired()"
              />
              @if (fiscalCodeField.invalid && fiscalCodeField.touched) {
                @if (fiscalCodeField.errors?.['required']) {
                  <small class="text-red-500" role="alert">Campo obbligatorio</small>
                } @else if (fiscalCodeField.errors?.['pattern']) {
                  <small class="text-red-500" role="alert">Formato non valido. Inserire un codice fiscale valido (16 caratteri alfanumerici o 11 cifre)</small>
                }
              }
            </div>

            <!-- Partita IVA -->
            <div class="field col-12 md:col-6">
              <label for="vatNumber" class="font-semibold block mb-2">
                Partita IVA 
                @if (isVatNumberRequired()) {
                  <span class="text-red-500" aria-hidden="true">*</span>
                }
              </label>
              <input
                pInputText
                id="vatNumber"
                name="vatNumber"
                #vatNumberField="ngModel"
                [(ngModel)]="preRegister()['vatNumber']"
                placeholder="es. 12345678901"
                class="w-full"
                maxlength="11"
                minlength="11"
                inputmode="numeric"
                pattern="^[0-9]{11}$"
                [required]="isVatNumberRequired()"
              />
              @if (vatNumberField.invalid && vatNumberField.touched) {
                @if (vatNumberField.errors?.['required']) {
                  <small class="text-red-500" role="alert">Campo obbligatorio</small>
                } @else if (vatNumberField.errors?.['pattern'] || vatNumberField.errors?.['minlength']) {
                  <small class="text-red-500" role="alert">Formato non valido. Inserire esattamente 11 cifre numeriche</small>
                }
              }
            </div>

            <!-- Email -->
            <div class="field col-12 md:col-6">
              <label for="registrationEmail" class="font-semibold block mb-2">
                Email 
                <span class="text-red-500" aria-hidden="true">*</span>
              </label>
              <input
                pInputText
                id="registrationEmail"
                name="registrationEmail"
                #registrationEmailField="ngModel"
                [(ngModel)]="preRegister()['registrationEmail']"
                type="email"
                class="w-full"
                placeholder="email@esempio.it"
                pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                email
                required
              />
              @if (registrationEmailField.invalid && registrationEmailField.touched) {
                @if (registrationEmailField.errors?.['required']) {
                  <small class="text-red-500" role="alert">Campo obbligatorio</small>
                }
                @if (registrationEmailField.errors?.['pattern'] && !registrationEmailField.errors?.['required']) {
                  <small class="text-red-500" role="alert">Email non valida</small>
                }
                @if (registrationEmailField.errors?.['email'] && !registrationEmailField.errors?.['required'] && !registrationEmailField.errors?.['pattern']) {
                  <small class="text-red-500" role="alert">Formato email non valido</small>
                }
              }
            </div>

            <!-- Conferma Email -->
            <div class="field col-12 md:col-6">
              <label for="confirmRegistrationEmail" class="font-semibold block mb-2">
                Conferma Email 
                <span class="text-red-500" aria-hidden="true">*</span>
              </label>
              <input
                pInputText
                id="confirmRegistrationEmail"
                name="confirmRegistrationEmail"
                #confirmRegistrationEmailField="ngModel"
                [(ngModel)]="preRegister()['confirmRegistrationEmail']"
                type="email"
                class="w-full"
                placeholder="Conferma email"
                required
              />
              @if (confirmRegistrationEmailField.invalid && confirmRegistrationEmailField.touched) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
              @if (confirmRegistrationEmailField.touched && preRegister()['confirmRegistrationEmail'] && preRegister()['registrationEmail'] !== preRegister()['confirmRegistrationEmail']) {
                <small class="text-red-500" role="alert">Le email non corrispondono</small>
              }
            </div>
          </div>

          <!-- Submit Button -->
          <div class="flex justify-content-end gap-3 mt-4 pt-3 border-top-1 border-200">
            <p-button
              type="submit"
              label="Salva e Genera Link"
              icon="pi pi-check"
              severity="primary"
              [loading]="isLoading()"
            ></p-button>
          </div>
        </form>
      </section>
    }

    <!-- STEP 3: Generated Link Section (for both DIRECT and DELEGATED) -->
    @if (generatedInvitation(); as invitation) {
      <p-card>
        <div class="surface-100 border-round p-4 mb-3">
          <h3 class="text-lg font-semibold mb-3 flex align-items-center gap-2">
            <i class="pi pi-check-circle text-green-500"></i>
            Link Generato con Successo
          </h3>
          
          <p-message 
            severity="success" 
            [text]="registrationMode() === 'DELEGATED' ? 'Dati del fiduciario salvati e invito inviato con successo!' : 'Invito creato e inviato con successo!'"
            styleClass="w-full mb-3"
          ></p-message>
          
          <!-- Destinatario Info -->
          <div class="mb-3">
            <label class="font-semibold block mb-2">Destinatario:</label>
            <div class="text-color-secondary">
              <p class="m-0"><strong>{{ invitation.givenName }} {{ invitation.familyName }}</strong></p>
              <p class="m-0">{{ invitation.email }}</p>
            </div>
          </div>

          <div class="mb-3">
            <label class="font-semibold block mb-2">Link di Registrazione:</label>
            <div class="p-inputgroup flex">
              <input
                pInputText
                [value]="invitation.invitationLink"
                readonly
                class="flex-1"
              />
              <button
                pButton
                type="button"
                icon="pi pi-copy"
                (click)="copyToClipboard()"
                pTooltip="Copia link"
                tooltipPosition="top"
              ></button>
            </div>
          </div>

          <div class="mb-3">
            <label class="font-semibold block mb-2">Modalità Selezionata:</label>
            <p class="text-color-secondary m-0">
              @if (registrationMode() === 'DIRECT') {
                Registrazione Diretta - Il fiduciario compilerà i dati autonomamente
              } @else {
                Registrazione Delegata - Dati già compilati per il fiduciario
              }
            </p>
          </div>

          <div class="mb-3">
            <label class="font-semibold block mb-2">Scadenza:</label>
            <p class="text-color-secondary m-0">{{ invitation.expiresAt | date: 'dd/MM/yyyy HH:mm' }}</p>
          </div>

          <p-message 
            severity="info" 
            text="L'email di invito è stata inviata automaticamente. Il fiduciario riceverà il link per completare la registrazione."
            styleClass="w-full"
          ></p-message>
        </div>

        <!-- Action Buttons -->
        <div class="flex justify-content-center">
          <p-button
            label="Crea Nuovo Invito"
            icon="pi pi-plus"
            severity="secondary"
            [disabled]="isLoading()"
            (onClick)="resetFormAndInvitation()"
          ></p-button>
        </div>
      </p-card>
    }

    <!-- Info Section -->
    <div class="surface-0 border-round p-4 mt-4 shadow-1">
      <h3 class="text-lg font-semibold mb-3 flex align-items-center gap-2">
        <i class="pi pi-info-circle text-blue-500"></i>
        Come Funziona
      </h3>
      
      <div class="grid">
        <div class="col-12 md:col-6">
          <h4 class="font-semibold mb-2 flex align-items-center gap-2">
            <i class="pi pi-user" style="color: #00125b;"></i>
            Registrazione Diretta
          </h4>
          <ol class="line-height-3 pl-3 text-sm">
            <li class="mb-2">Genera il link inserendo solo l'email</li>
            <li class="mb-2">Invia il link al fiduciario</li>
            <li class="mb-2">Il fiduciario accede via CIAM</li>
            <li>Il fiduciario compila autonomamente i dati</li>
          </ol>
        </div>
        
        <div class="col-12 md:col-6">
          <h4 class="font-semibold mb-2 flex align-items-center gap-2">
            <i class="pi pi-users" style="color: #00125b;"></i>
            Registrazione Delegata
          </h4>
          <ol class="line-height-3 pl-3 text-sm">
            <li class="mb-2">Compila i dati per conto del fiduciario</li>
            <li class="mb-2">Il sistema genera automaticamente il link</li>
            <li class="mb-2">Invia il link al fiduciario</li>
            <li>Il fiduciario accede via CIAM per gli step successivi</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
}

<!-- ========================================== -->
<!-- FIDUCIARIO USER VIEW: Normal Form -->
<!-- ========================================== -->
@if (!isAXAUser() && showForm()) {
<div class="wizard-container p-6 w-full">
  <!-- Page Header -->
  <section class="page-header mb-5" aria-labelledby="page-heading-fid">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-user-plus header-icon" aria-hidden="true"></i>
        <div class="header-text">
          <h1 id="page-heading-fid">Registrazione Nuovo Fiduciario</h1>
          <p class="subtitle">Inserisci i dati anagrafici completi</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Sezione Dati Anagrafici -->
  <section class="surface-0 border-round p-5 mb-4 shadow-1" aria-labelledby="dati-anagrafici-heading">
    <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
      <i class="pi pi-user text-2xl" style="color: #00125b;" aria-hidden="true"></i>
      <h2 id="dati-anagrafici-heading" class="text-xl font-semibold m-0" style="color: #00125b;">Dati Anagrafici</h2>
    </div>

    <!-- Form con ruolo esplicito -->
    <form (ngSubmit)="save()" role="form" aria-labelledby="dati-anagrafici-heading" #preRegistrationForm="ngForm" class="p-fluid">
      <div class="grid">
      <!-- 1. Categoria Fiduciario -->
      <div class="field col-12 md:col-6">
        <label for="type" class="font-semibold block mb-2">
          Categoria Fiduciario 
          <span class="text-red-500" aria-hidden="true">*</span>
        </label>
        <p-select
          inputId="type"
          name="type"
          #typeField="ngModel"
          [options]="tipologieOptions()"
          [ngModel]="preRegister()['type']"
          (ngModelChange)="onFiduciarioChange($event)"
          optionLabel="name"
          optionValue="code"
          placeholder="Seleziona categoria"
          class="w-full"
          [attr.aria-required]="true"
          [attr.aria-invalid]="typeField.invalid && typeField.touched"
          [attr.aria-describedby]="typeField.invalid && typeField.touched ? 'type-error' : null"
          required
        ></p-select>
        @if (typeField.invalid && typeField.touched) {
          <small id="type-error" class="text-red-500" role="alert">Campo obbligatorio</small>
        }
      </div>

      <!-- 2. Categoria Carrozzeria (Conditional) -->
      @if (isBodyShopSelected()) {
        <div class="field col-12 md:col-6">
          <label for="bodyShopType" class="font-semibold block mb-2">
            Categoria Carrozzeria 
            <span class="text-red-500" aria-hidden="true">*</span>
          </label>
          <p-select
            inputId="bodyShopType"
            name="bodyShopType"
            #bodyShopTypeField="ngModel"
            [options]="bodyworkOptions()"
            [ngModel]="preRegister()['bodyShopType']"
            (ngModelChange)="onBodyShopTypeChange($event)"
            optionLabel="name"
            optionValue="code"
            placeholder="Seleziona categoria carrozzeria"
            class="w-full"
            [attr.aria-required]="true"
            [attr.aria-invalid]="bodyShopTypeField.invalid && bodyShopTypeField.touched"
            [attr.aria-describedby]="bodyShopTypeField.invalid && bodyShopTypeField.touched ? 'bodyShopType-error' : null"
            required
          ></p-select>
          @if (bodyShopTypeField.invalid && bodyShopTypeField.touched) {
            <small id="bodyShopType-error" class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
      }

      <!-- 3. Persona Giuridica o Fisica -->
      <div class="field col-12 md:col-6">
        <label for="legalOrPhysical" class="font-semibold block mb-2">
          Persona Giuridica o Fisica 
          <span class="text-red-500" aria-hidden="true">*</span>
        </label>
        <p-select
          inputId="legalOrPhysical"
          name="legalOrPhysical"
          #legalOrPhysicalField="ngModel"
          [options]="personTypeOptions()"
          [ngModel]="preRegister()['legalOrPhysical']"
          (ngModelChange)="onPersonTypeChange($event)"
          optionLabel="label"
          optionValue="value"
          placeholder="Seleziona tipo persona"
          class="w-full"
          [attr.aria-required]="true"
          [attr.aria-invalid]="legalOrPhysicalField.invalid && legalOrPhysicalField.touched"
          [attr.aria-describedby]="legalOrPhysicalField.invalid && legalOrPhysicalField.touched ? 'legalOrPhysical-error' : null"
          required
        ></p-select>
        @if (legalOrPhysicalField.invalid && legalOrPhysicalField.touched) {
          <small id="legalOrPhysical-error" class="text-red-500" role="alert">Campo obbligatorio</small>
        }
      </div>

      <!-- 4. Ragione Sociale (for GIURIDICA) -->
      <div class="field col-12 md:col-6">
        <label for="businessName" class="font-semibold block mb-2">
          Ragione Sociale
          @if (isBusinessNameRequired()) {
            <span class="text-red-500" aria-hidden="true">*</span>
          }
        </label>
        <input
          pInputText
          id="businessName"
          name="businessName"
          #businessNameField="ngModel"
          [(ngModel)]="preRegister()['businessName']"
          class="w-full"
          placeholder="Denominazione dell'azienda"
          [attr.aria-required]="isBusinessNameRequired()"
          [attr.aria-invalid]="businessNameField.invalid && businessNameField.touched"
          [attr.aria-describedby]="businessNameField.invalid && businessNameField.touched ? 'businessName-error' : null"
          autocomplete="organization"
          [required]="isBusinessNameRequired()"
        />
        @if (businessNameField.invalid && businessNameField.touched) {
          <small id="businessName-error" class="text-red-500" role="alert">Campo obbligatorio</small>
        }
        <small class="block mt-1 text-600">Non inserire il tipo di società</small>
      </div>

      <!-- Tipo Società  -->
        <div class="field col-12 md:col-4">
          <label for="tipo-societa" class="font-semibold block mb-2">
            Tipo Società <span class="text-red-500" aria-hidden="true">*</span>
          </label>
          <p-select
            inputId="companyType"
            name="companyType"
            #companyTypeField="ngModel"
            [ngModel]="preRegister()['companyType']"
            (ngModelChange)="onCompanyTypeChange($event)"
            [options]="filteredSupplierTypes()"
            optionLabel="label"
            optionValue="value"
            optionDisabled="disabled"
            panelStyleClass="company-type-select-panel"
            placeholder="-- Seleziona --"
            [filter]="true"
            [showClear]="true"
            class="w-full"
            required
          ></p-select>
          @if (companyTypeField.invalid && companyTypeField.touched) {
            <small id="companyType-error" class="text-red-500" role="alert">
              Campo obbligatorio
            </small>
          }
        </div>

      <!-- 6. Cognome -->
      <div class="field col-12 md:col-6">
        <label for="lastName" class="font-semibold block mb-2">
          Cognome Rappresentante Legale
          @if (isLastNameRequired()) {
            <span class="text-red-500" aria-hidden="true">*</span>
          }
        </label>
        <input
          pInputText
          id="lastName"
          name="lastName"
          #lastNameField="ngModel"
          [(ngModel)]="preRegister()['lastName']"
          class="w-full"
          placeholder="Cognome del titolare"
          [attr.aria-required]="isLastNameRequired()"
          [attr.aria-invalid]="lastNameField.invalid && lastNameField.touched"
          [attr.aria-describedby]="lastNameField.invalid && lastNameField.touched ? 'lastName-error' : null"
          autocomplete="family-name"
          [required]="isLastNameRequired()"
        />
        @if (lastNameField.invalid && lastNameField.touched) {
          <small id="lastName-error" class="text-red-500" role="alert">Campo obbligatorio</small>
        }
      </div>

      <!-- 5. Nome -->
      <div class="field col-12 md:col-6">
        <label for="firstName" class="font-semibold block mb-2">
          Nome Rappresentante Legale
          @if (isFirstNameRequired()) {
            <span class="text-red-500" aria-hidden="true">*</span>
          }
        </label>
        <input
          pInputText
          id="firstName"
          name="firstName"
          #firstNameField="ngModel"
          [(ngModel)]="preRegister()['firstName']"
          class="w-full"
          placeholder="Nome del titolare"
          [attr.aria-required]="isFirstNameRequired()"
          [attr.aria-invalid]="firstNameField.invalid && firstNameField.touched"
          [attr.aria-describedby]="firstNameField.invalid && firstNameField.touched ? 'firstName-error' : null"
          autocomplete="given-name"
          [required]="isFirstNameRequired()"
        />
        @if (firstNameField.invalid && firstNameField.touched) {
          <small id="firstName-error" class="text-red-500" role="alert">Campo obbligatorio</small>
        }
      </div>

      <!-- 7. Codice Fiscale -->
      <div class="field col-12 md:col-6">
        <label for="fiscalCode" class="font-semibold block mb-2">
          Codice Fiscale 
          @if (isFiscalCodeRequired()) {
            <span class="text-red-500" aria-hidden="true">*</span>
          }
        </label>
        <input
          pInputText
          id="fiscalCode"
          name="fiscalCode"
          #fiscalCodeField="ngModel"
          [ngModel]="preRegister()['fiscalCode']"
          (ngModelChange)="updatePreRegistrationFiscalCode($event)"
          placeholder="es. RSSMRA80A01H501U o es. 12345678901"
          class="w-full"
          [attr.aria-required]="isFiscalCodeRequired()"
          [attr.aria-invalid]="fiscalCodeField.invalid && fiscalCodeField.touched"
          [attr.aria-describedby]="fiscalCodeField.invalid && fiscalCodeField.touched ? 'fiscalCode-error' : null"
          maxlength="16"
          pattern="^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})|([0-9]{11})$"
          [required]="isFiscalCodeRequired()"
        />
        @if (fiscalCodeField.invalid && fiscalCodeField.touched) {
          @if (fiscalCodeField.errors?.['required']) {
            <small id="fiscalCode-error" class="text-red-500" role="alert">Campo obbligatorio</small>
          } @else if (fiscalCodeField.errors?.['pattern']) {
            <small id="fiscalCode-error" class="text-red-500" role="alert">Formato non valido. Inserire un codice fiscale valido (16 caratteri alfanumerici o 11 cifre)</small>
          }
        }
      </div>

      <!-- 8. Partita IVA -->
      <div class="field col-12 md:col-6">
        <label for="vatNumber" class="font-semibold block mb-2">
          Partita IVA 
          @if (isVatNumberRequired()) {
            <span class="text-red-500" aria-hidden="true">*</span>
          }
        </label>
        <input
          pInputText
          id="vatNumber"
          name="vatNumber"
          #vatNumberField="ngModel"
          [(ngModel)]="preRegister()['vatNumber']"
          placeholder="es. 12345678901"
          class="w-full"
          [attr.aria-required]="isVatNumberRequired()"
          [attr.aria-invalid]="vatNumberField.invalid && vatNumberField.touched"
          [attr.aria-describedby]="vatNumberField.invalid && vatNumberField.touched ? 'vatNumber-error' : null"
          maxlength="11"
          minlength="11"
          inputmode="numeric"
          pattern="^[0-9]{11}$"
          [required]="isVatNumberRequired()"
        />
        @if (vatNumberField.invalid && vatNumberField.touched) {
          @if (vatNumberField.errors?.['required']) {
            <small id="vatNumber-error" class="text-red-500" role="alert">Campo obbligatorio</small>
          } @else if (vatNumberField.errors?.['pattern'] || vatNumberField.errors?.['minlength']) {
            <small id="vatNumber-error" class="text-red-500" role="alert">Formato non valido. Inserire esattamente 11 cifre numeriche</small>
          }
        }
      </div>

      <!-- 9. Email (Hidden for Professional users who use their CIAM email) -->
      @if (!isProfessionalUser()) {
      <div class="field col-12 md:col-6">
        <label for="registrationEmail" class="font-semibold block mb-2">
          Email 
          <span class="text-red-500" aria-hidden="true">*</span>
        </label>
        <input
          pInputText
          id="registrationEmail"
          name="registrationEmail"
          #registrationEmailField="ngModel"
          [(ngModel)]="preRegister()['registrationEmail']"
          type="email"
          class="w-full"
          placeholder="email@esempio.it"
          [attr.aria-required]="true"
          [attr.aria-invalid]="registrationEmailField.invalid && registrationEmailField.touched"
          [attr.aria-describedby]="registrationEmailField.invalid && registrationEmailField.touched ? 'registrationEmail-error' : null"
          autocomplete="email"
          pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
          email
          required
        />
        @if (registrationEmailField.invalid && registrationEmailField.touched) {
          @if (registrationEmailField.errors?.['required']) {
            <small id="registrationEmail-error" class="text-red-500" role="alert">Campo obbligatorio</small>
          }
          @if (registrationEmailField.errors?.['pattern'] && !registrationEmailField.errors?.['required']) {
            <small id="registrationEmail-format-error" class="text-red-500" role="alert">Email non valida. Deve contenere @ e un dominio completo (es: nome@dominio.it)</small>
          }
          @if (registrationEmailField.errors?.['email'] && !registrationEmailField.errors?.['required'] && !registrationEmailField.errors?.['pattern']) {
            <small id="registrationEmail-format-error" class="text-red-500" role="alert">Formato email non valido</small>
          }
        }
      </div>

      <!-- 10. Conferma Email (Hidden for Professional users) -->
      <div class="field col-12 md:col-6">
        <label for="confirmRegistrationEmail" class="font-semibold block mb-2">
          Conferma Email 
          <span class="text-red-500" aria-hidden="true">*</span>
        </label>
        <input
          pInputText
          id="confirmRegistrationEmail"
          name="confirmRegistrationEmail"
          #confirmRegistrationEmailField="ngModel"
          [(ngModel)]="preRegister()['confirmRegistrationEmail']"
          type="email"
          class="w-full"
          placeholder="Conferma email"
          [attr.aria-required]="true"
          [attr.aria-invalid]="confirmRegistrationEmailField.invalid && confirmRegistrationEmailField.touched"
          [attr.aria-describedby]="confirmRegistrationEmailField.invalid && confirmRegistrationEmailField.touched ? 'confirmRegistrationEmail-error' : null"
          autocomplete="email"
          required
        />
        @if (confirmRegistrationEmailField.invalid && confirmRegistrationEmailField.touched) {
          <small id="confirmRegistrationEmail-error" class="text-red-500" role="alert">Campo obbligatorio</small>
        }
        @if (confirmRegistrationEmailField.touched && preRegister()['confirmRegistrationEmail'] && preRegister()['registrationEmail'] !== preRegister()['confirmRegistrationEmail']) {
          <small class="text-red-500" role="alert">Le email non corrispondono</small>
        }
      </div>
      }
    </div>

      <!-- Actions Footer -->
      <div class="flex justify-content-end gap-3 mt-4 pt-3 border-top-1 border-200">
        <p-button
          type="submit"
          label="Salva"
          icon="pi pi-check"
          severity="primary"
          aria-label="Salva registrazione fiduciario"
        ></p-button>
      </div>
    </form>
  </section>
</div>
}

<p-confirmDialog role="alertdialog" aria-modal="true" />

